import { render, staticRenderFns } from "./ActivityCoupon.vue?vue&type=template&id=28f2513a&scoped=true"
import script from "./ActivityCoupon.vue?vue&type=script&lang=js"
export * from "./ActivityCoupon.vue?vue&type=script&lang=js"
import style0 from "./ActivityCoupon.vue?vue&type=style&index=0&id=28f2513a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2513a",
  null
  
)

export default component.exports